import { createApp, onMounted, reactive } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'amfe-flexible';
import './plugins/utils'
import { Row, Col, Icon, Toast, Overlay, Step, Steps, Swipe, SwipeItem, Progress,  Image, Search, Popup, Tab, Tabs, Rate, Button, Dialog, CountDown, Form, Badge, List, Field, Tabbar, TabbarItem,Lazyload ,Divider,Checkbox, CheckboxGroup,RadioGroup, Radio,Popover,Switch,DatetimePicker,Uploader,DropdownMenu, DropdownItem ,Skeleton,ActionBar, ActionBarIcon, ActionBarButton,Stepper,SubmitBar,ActionSheet,IndexBar, IndexAnchor,Loading,CellGroup,Cell,ImagePreview,ShareSheet, Collapse, CollapseItem,Calendar   } from 'vant';
import './assets/css/base.css';
import http from './plugins/http'
import {kl_store} from './plugins/store'
import { VueClipboard } from '@soerenmartius/vue3-clipboard'
import 'vant/lib/index.less';
import gAuthPlugin from 'vue3-google-oauth2';
import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import '@/permission'
// import api_config from '../server_config/http'

const app:any = createApp(App)
let store = new kl_store();
export const useStore = ()=>{
    return reactive(store)
}

(async () => {
    if( store.getSite() === null ) {  
        let ret = await http.site({code: 'ke'})
        if(ret.code === 200 && ret.data) {
            store.setSite(ret.data)
        }
    }
    
})()
app.config.globalProperties.webpFilters = function (value:any) {
    return value && value.webpFilters()
  }
app.config.globalProperties.store = store
app.config.globalProperties.$http = http

app.directive('focus',{
    beforeMount(el:any){    
    },
    mounted(el:any,binding:any){
        const input:any = document.getElementsByClassName(
            "van-field__control"
            )[0];
            input.focus();               
    }
})

app.config.globalProperties.$get_facebook_appId=function(){
    let code = window.location.href;
    let appId='';
    if(code.indexOf('kilitest')>-1){
        appId='685657534931756';
    }else{
        appId='951665321609204';
    }
    // else if(code === 'ug'){
    //    appId='1152254798171154';
    // }else if(code === 'ng'){
    //     appId='111382932654912'; 
    // }else{
    //     appId='685657534931756'; 
    // }
    return appId;
}

const gauthClientId = "214923478109-ot56okp0olmetmaih8va0eo5k4pk8m47.apps.googleusercontent.com";


app.use(router)
.use(Row)
.use(Col)
.use(ActionSheet)
.use(Icon)
.use(Popup)
.use(Tab)
.use(Tabs)
.use(Rate)
.use(Button)
.use(CountDown)
.use(Form)
.use(Dialog)
.use(Toast)
.use(Swipe)
.use(SwipeItem)
.use(Image)
.use(Search)
.use(Badge)
.use(List)
.use(Field)
.use(Tabbar)
.use(TabbarItem)
.use(RadioGroup)
.use(Radio)
.use(Divider)
.use(Checkbox)
.use(CheckboxGroup)
.use(Lazyload,{
    preLoad: 1.3,
    error: 'https://image.kilimall.com/kenya/new_wap/goods/goods_defiult.png'.webpFilters()
    ,
    loading: 'https://image.kilimall.com/kenya/new_wap/goods/goods_defiult.png'.webpFilters()
    ,
    // loading: 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJsb2FkZXItMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMnB4IiBoZWlnaHQ9IjIycHgiIHZpZXdCb3g9IjAgMCA1MCA1MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTAgNTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCiAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTQzLjkzNSwyNS4xNDVjMC0xMC4zMTgtOC4zNjQtMTguNjgzLTE4LjY4My0xOC42ODNjLTEwLjMxOCwwLTE4LjY4Myw4LjM2NS0xOC42ODMsMTguNjgzaDQuMDY4YzAtOC4wNzEsNi41NDMtMTQuNjE1LDE0LjYxNS0xNC42MTVjOC4wNzIsMCwxNC42MTUsNi41NDMsMTQuNjE1LDE0LjYxNUg0My45MzV6IiB0cmFuc2Zvcm09InJvdGF0ZSg4MCAyNSAyNSkiPg0KICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZVR5cGU9InhtbCIgYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMjUgMjUiIHRvPSIzNjAgMjUgMjUiIGR1cj0iMC44cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZVRyYW5zZm9ybT4NCiAgICA8L3BhdGg+DQogIDwvc3ZnPg==',
    attempt: 1
  //   listenEvents: [ 'scroll', 'mousewheel' ]
  })
  .use(Popover)
  .use(Switch)
  .use(DatetimePicker)
  .use(Uploader)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(ActionSheet)
  .use(Loading)
  .use(CellGroup)
  .use(Cell)
  .use(Skeleton)
  .use(ActionBar)
  .use(ActionBarIcon)
  .use(ActionBarButton)
  .use(Stepper)
  .use(Step)
  .use(Steps)
  .use(VueClipboard)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Overlay)
  .use(ImagePreview)
  .use(ShareSheet)
  .use(Collapse)
  .use(CollapseItem)
  .use(Calendar )
  .use(Progress)
  .use(gAuthPlugin, { clientId: gauthClientId, scope: 'email', prompt: 'consent', fetch_basic_profile: false })
  .use(VideoPlayer)
.mount('#app')
